import React from 'react';

export const pageMeta = {
  "name": "JS Typed Arrays",
  "link": "/javascript/typed-arrays"
};

export default function JavascriptTypedArrays() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Typed Arrays</h2>
      <p>Route: /javascript/typed-arrays</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
